module.exports = __webpack_public_path__ + "static/gallery11-49981a555d800e20657c6a73b4f247e8.png";